export function multipleProtectedRouteBeforeLoad(
  ...checkers: (() => unknown)[]
): object | null | undefined {
  for (const checker of checkers) {
    const result = checker();
    if (result !== undefined) {
      return result;
    }
  }
  return undefined;
}
